var _rect, _line, _rect2, _rect3, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 31,
    height: 28,
    rx: 4,
    fill: "white",
    stroke: "#756F6F",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 11,
    x2: 32,
    y2: 11,
    stroke: "#756F6F",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.75,
    y: 0.75,
    width: 1.5,
    height: 5.5,
    rx: 0.75,
    fill: "white",
    stroke: "#756F6F",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.75,
    y: 0.75,
    width: 1.5,
    height: 5.5,
    rx: 0.75,
    fill: "white",
    stroke: "#756F6F",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 30,
    r: 10,
    fill: "white",
    stroke: "#756F6F",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 25V25.5V31L32.5 34.5",
    stroke: "#756F6F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTimeline);
export default __webpack_public_path__ + "static/media/NoTimeline.162ad7addf3f8f60770938564a10c47d.svg";
export { ForwardRef as ReactComponent };